import { render, staticRenderFns } from "./ModalInibirRestricoes.vue?vue&type=template&id=f7865718&lang=pug"
import script from "./ModalInibirRestricoes.vue?vue&type=script&lang=js"
export * from "./ModalInibirRestricoes.vue?vue&type=script&lang=js"
import style0 from "./ModalInibirRestricoes.vue?vue&type=style&index=0&id=f7865718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports